import { Article, Link, useIntl, useNextArticle, usePrevArticle } from 'topwrite';
import style from '../scss/main.module.scss';

export default function Document() {

    const intl = useIntl();

    const prevArticle = usePrevArticle();
    const nextArticle = useNextArticle();

    return <div className={style.main}>
        <Article
            offset={56}
            className={style.content}
            footer={
                <div className={style.navigation}>
                    {prevArticle && <span className={style.prev}>
                        {intl.formatMessage({ defaultMessage: '上一篇' })}:<Link
                        to={prevArticle}>{prevArticle.title}</Link>
                    </span>}
                    {nextArticle && <span className={style.next}>
                        {intl.formatMessage({ defaultMessage: '下一篇' })}:<Link
                        to={nextArticle}>{nextArticle.title}</Link>
                    </span>}
                </div>}
        />
    </div>;
}
